/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { FleetDevice, FleetDevice$inboundSchema } from "./fleetdevice.js";

export type ListFleetDevicesResult = {
  /**
   * Devices, newest first.
   */
  devices: Array<FleetDevice>;
  /**
   * Cursor for the next page. Omitted on the last page.
   */
  nextCursor?: string | undefined;
};

/** @internal */
export const ListFleetDevicesResult$inboundSchema: z.ZodMiniType<
  ListFleetDevicesResult,
  unknown
> = z.pipe(
  z.object({
    devices: z.array(FleetDevice$inboundSchema),
    next_cursor: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "next_cursor": "nextCursor",
    });
  }),
);

export function listFleetDevicesResultFromJSON(
  jsonString: string,
): SafeParseResult<ListFleetDevicesResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListFleetDevicesResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListFleetDevicesResult' from JSON`,
  );
}
